<template>
  <div class="reporting-main-section flex-grow-1 d-flex overflow-hidden">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "ReportingMainSection"
}
</script>

<style lang="scss">
.reporting-main-section {
  background: #fff !important;

  .card {
    margin-bottom: 20px;
    border-radius: 8px;

    .card-body {
      padding: 17px;
    }
  }
}
</style>
